import { useEffect } from "react";
function useOnSizeChange(elementSize, onSizeChange) {
  const { width, height } = elementSize;
  useEffect(() => {
    onSizeChange?.({ width, height });
  }, [width, height, onSizeChange]);
}
export {
  useOnSizeChange
};
//# sourceMappingURL=useOnSizeChange.js.map
